module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Incoming-call-d16496ec32c4c6d9b7b34ef9d6e8de8c.svg";